import messages from './floating-sidemenu-translations';
import * as $ from 'jquery';
import * as _ from 'lodash';
import tooltip from 'vue-simple-tooltip';
import mapHelpSearch from './helpSearch.vue';

export default {
    name: 'mapViewerFloatingSidemenu',
    directives: { tooltip },
    i18n: {
        messages,
    },
    data: function () {
        return {
            isShown: undefined,
            sections: {
                ACTIONS: 1,
                SEARCH: 2,
            },
            exportType: {
                IMAGE: 1,
                PRINT: 2,
                GEOPDF: 3,
                GEOTIFF: 4,
                GEOPACKAGE: 5,
                PRINTSCALE: 6,
                DOWNLOADLAYER: 7,
            },
            selectedSection: undefined,
            state: {
                legendItem: {
                    isExpanded: false,
                    items: this.legend,
                },
                layersItem: {
                    isExpanded: false,
                    items: this.layers,
                },
                backgroundsItem: {
                    isExpanded: false,
                    items: this.backgrounds,
                },
                exportItem: {
                    isExpanded: false,
                    items: [],
                },
                shareItem: {
                    isExpanded: false,
                    items: [],
                },
            },
            selectedLayersGroup: 0,
            searchResults: [],
            searchInput: '',
            searchControl: null,
        };
    },
    components: {
        mapHelpSearch
    },
    props: {
        selectedLang: {
            type: String,
        },
        legend: {
            type: Array,
        },
        layers: {
            type: Array,
        },
        layersState: {
            type: Array,
        },
        backgrounds: {
            type: Array,
        },
        name: {
            type: String,
        },
        legendOpen: {
            type: Boolean,
        },
        instamapsConfig: {
            type: Object,
        },
        isInIframe: {
            type: Boolean,
        },
        legendVisible: {
            type: Boolean,
        },
    },
    computed: {
        isMobile: function () {
            try {
                if (/Android|webOS|iPhone|iPad|iPod|pocket|psp|kindle|avantgo|blazer|midori|Tablet|Palm|maemo|plucker|phone|BlackBerry|symbian|IEMobile|mobile|ZuneWP7|Windows Phone|Opera Mini/i.test(navigator.userAgent)) {
                    return true;
                }
                return false;
            } catch (e) { console.log("Error in isMobile"); return false; }
        },
    },
    watch: {
        'legendOpen': function () {
            this.state.legendItem.isExpanded = this.legendOpen;
            this.isShown = this.legendOpen;
            this.selectedSection = this.sections.ACTIONS;
            this.legendVisible = this.legendVisible;
        },
        'backgrounds': function () {
            this.state.backgroundsItem.items = this.backgrounds;
        },
        'legend': function () {
            this.state.legendItem.items = this.legend;
        },
        'layers': function () {
            this.state.layersItem.items = this.layers;
        },
        'legendVisible': function () {
            this.legendVisible = this.legendVisible;
        },
    },
    methods: {
        search: function () {
            var input = this.searchInput;
            if (input.indexOf(" like ") > -1) input = input.replace(" like ", "_like_");
            var businessId = this.businessId;
            var self = this;
            //Afegim icona de loader
            $('#searchControl')[0].style = "background: url(/static/geocatweb/css/images/loader.gif) no-repeat center right #FFF;height: 33px;";
            // eslint-disable-next-line no-undef 
            if (input.length >= 3) {
                if (self.searchControl._areCoordinates(input)) {
                    //Convert coordinates in the client side instead of doing a request to the server
                    var jsonraw = self.searchControl._convertCoordinates(input);

                    //If we can convert, disable show the tooltip and remove the search icon
                    if (jsonraw.features && Array.isArray(jsonraw.features)) {
                        var resultats = jsonraw.features.map(function (feature) {
                            var props = feature.properties || {};
                            var geometry = feature.geometry || {};
                            return {
                                // camps que Vue espera
                                nom: props.etiqueta || props.nom || "",
                                origen: props.origen || props.source || "ICGC",
                                geometria: geometry,
                                businessidVis: businessId,
                                coordenades:
                                    (geometry.type === "Point" && geometry.coordinates)
                                        ? geometry.coordinates[0] + "," + geometry.coordinates[1]
                                        : null,
                                feature: feature
                            };
                        });


                        var jsonrawNew = {
                            status: 'OK',
                            resposta: JSON.stringify({
                                resultats: resultats
                            })
                        };



                        var resultats = JSON.parse(jsonrawNew.resposta).resultats;


                    } else {
                        var resultats = JSON.parse(jsonraw.resposta).resultats;
                    }


                    $('#searchControl')[0].style = "height: 33px;";
                    self.searchResults = resultats;
                } else {
                    // eslint-disable-next-line no-undef 
                    search(input).then(data => {

                        //traiem icona de loader
                        if (data.features && Array.isArray(data.features)) {
                            var resultats = data.features.map(function (feature) {
                                var props = feature.properties || {};
                                var geometry = feature.geometry || {};
                                return {
                                    // camps que Vue espera
                                    nom: props.etiqueta || props.nom || "",
                                    origen: props.origen || props.source || "ICGC",
                                    geometria: geometry,
                                    businessidVis: businessId,
                                    coordenades:
                                        (geometry.type === "Point" && geometry.coordinates)
                                            ? geometry.coordinates[0] + "," + geometry.coordinates[1]
                                            : null,
                                    feature: feature
                                };
                            });


                            var dataNew = {
                                status: 'OK',
                                resposta: JSON.stringify({
                                    resultats: resultats
                                })
                            };




                          
                            $('#searchControl')[0].style = "height: 33px;";
                            if (dataNew.status === 'OK') {
                                self.searchResults = JSON.parse(dataNew.resposta).resultats;
                            }
                        } else {
                            $('#searchControl')[0].style = "height: 33px;";
                            if (data.status === 'OK') {
                                self.searchResults = JSON.parse(data.resposta).resultats;
                            }

                        }





                    });
                }
            } else {
                $('#searchControl')[0].style = "height: 33px;";
                self.searchResults = [];
            }

        },
        cleanLayerName: function (name) {
            if (name !== undefined) return name.split("##")[0];
            else return name;
        },
        checkLegendVisible: function () {
            return (this.state.legendItem && this.state.legendItem.items.length > 0 && this.legendVisible);
        },
        getLayerState: function (id) {
            var currentCapa = _.find(this.layersState, { businessId: id });
            var isLayerActive = currentCapa ? currentCapa.activa : false;
            return isLayerActive;
        },
        isWmsLayer: function (layer) {
            var lay_options = layer.options;
            if (_.isString(lay_options)) {
                try {
                    lay_options = JSON.parse(layer.options);
                }
                catch (e) {
                    return false;
                }
            }
            if (layer.serverType === 'wms' && lay_options.hasOwnProperty('url') && lay_options.hasOwnProperty('layers')) {
                return true;
            } else {
                return false;
            }
        },
        isSostenibilitat: function (layer) {
            var lay_options = layer.options;
            if (_.isString(lay_options)) {
                try {
                    lay_options = JSON.parse(layer.options);
                }
                catch (e) {
                    return false;
                }

            }
            if (lay_options.hasOwnProperty('sostenibilitat') && lay_options.sostenibilitat === true) {
                return true;
            } else {
                return false;
            }
        },
        changeOpacity: function (id) {
            var currentCapa = _.find(this.layersState, { businessId: id });
            var opacity = currentCapa.layer.options.opacity;

            if (!currentCapa.activa) {
                opacity = 1;
                currentCapa.layer.setOpacity(opacity);
                this.toggleLayer(id);
            } else {
                opacity = opacity - 0.25;
                if (opacity < 0) {
                    opacity = 1;
                }
                currentCapa.layer.setOpacity(opacity);
                if (opacity === 0 && currentCapa.activa) {
                    this.toggleLayer(id);
                }
            }
        },
        getLayerOpacity: function (id) {
            var currentCapa = _.find(this.layersState, { businessId: id });
            if (currentCapa) {
                if (!currentCapa.activa) {
                    return 0;
                } else {
                    return currentCapa.layer.options.opacity;
                }
            } else {
                return 1;
            }
        },
        release: function () {
            this.selectedSection = undefined;
            this.isShown = false;
        },
        getUniqueId: function (str, offset, key) {
            var uid = 0;
            for (var i = 0; i < str.length; i++) {
                uid = uid + str.charCodeAt(i) + offset;
            }
            return key + '_' + uid;
        },
        toggleSection: function (section) {

            if (this.selectedSection === section) {
                this.release();
            } else {
                this.selectedSection = section;
                this.isShown = true;
            }

        },
        toggleItem: function (obj) {
            for (var p in this.state) {
                if (this.state.hasOwnProperty(p)) {
                    if (this.state[p] !== obj) { this.state[p].isExpanded = false; }
                }
            }

            obj.isExpanded = !obj.isExpanded;
        },
        toggleSubItem: function (id) {
            if ($('#' + id).hasClass('expand')) {
                $('#' + id).removeClass('expand');
                $('#' + id).parent().find(".toggle-arrow").text('expand_more');
            } else {
                $('#' + id).addClass('expand');
                $('#' + id).parent().find(".toggle-arrow").text('expand_less');
            }

        },
        mustExpand: function (sublayers) {
            var self = this;
            let actives = sublayers.filter(function (layer) {
                return self.getLayerState(layer.businessId);
            });
            return actives.length > 0 ? true : false;
        },
        expandIcon: function (sublayers) {
            var icon = (this.mustExpand(sublayers)) ? 'expand_less' : 'expand_more';
            return icon;
        },
        printLegend: function () {
            // eslint-disable-next-line no-undef
            capturaLlegenda();
        },
        toggleLayer: function (businessId) {
            // eslint-disable-next-line no-undef 
            toggleCapa(businessId);
        },
        toggleLayerSostenibilitat: function (businessId) {
            // eslint-disable-next-line no-undef
            var self = this;
            var currentCapa = _.find(self.layersState, { businessId: businessId });
            if (currentCapa) {
                if (currentCapa.activa) {
                    return 0;
                } else {
                    _.forEach(self.state.layersItem.items, function (group) {
                        _.forEach(group.layers, function (layer) {
                            if (self.isSostenibilitat(layer) && layer.businessId !== businessId) {
                                var capap = _.find(self.layersState, { businessId: layer.businessId });
                                if (capap) {
                                    if (capap.activa) {
                                        self.toggleLayer(layer.businessId);
                                    }
                                }
                            }
                        });
                    });
                    self.toggleLayer(businessId);
                }
            } else {
                return 1;
            }
        },
        toggle3D: function () {
            // eslint-disable-next-line no-undef 
            _3D();
        },
        goToLocation: function (searchResult) {
            var self = this;
            var coords = searchResult.coordenades;
            var name = searchResult.nom;
            var origen = searchResult.origen;
            var geometria = searchResult.geometria;
            var businessidVis = searchResult.businessidVis;
            // eslint-disable-next-line no-undef 
            if (origen === "ICGC") {
                var coordsSplit = coords.split(',');
                showLocation(L.latLng(coordsSplit[1], coordsSplit[0]), name);
            }
            else if (origen === "Dades del mapa") {
                self.changeLayerState(businessidVis);
                if (geometria !== undefined) {
                    if (geometria.type === "Point") {
                        var coordsSplit = geometria.coordinates;
                        map.panTo(L.latLng(coordsSplit[1], coordsSplit[0]));
                        map.setZoom(17);
                    }
                    else if (geometria.type === "LineString") {
                        var geom = L.GeoJSON.coordsToLatLngs(geometria.coordinates);
                        var line = L.polyline(geom);
                        map.fitBounds(line.getBounds());
                    }
                    else if (geometria.type === "Polygon") {
                        var geom = L.GeoJSON.coordsToLatLngs(geometria.coordinates);
                        var pol = L.polyline(geom);
                        map.fitBounds(pol.getBounds());
                    }
                }
            }
            else {
                var coordsSplit = coords.split(',');
                showLocation(L.latLng(coordsSplit[0], coordsSplit[1]), name);
            }

        },
        changeBackground: function (id) {
            var self = this;
            // eslint-disable-next-line no-undef 
            changeFonsVisor(id);
            self.$emit('changeBackground', {
                id: id,
            });
        },
        downloadFile: function (url, type) {
            var link = document.createElement('a');
            link.setAttribute('href', url);
            if (type == "geopackage") link.setAttribute('download', 'InstamapsExport.gpkg');
            else link.setAttribute('download', 'InstamapsExport');
            link.style.display = 'none';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        exportMap: function (type) {
            var self = this;

            self.showExportingModal(type);

            switch (type) {
                case self.exportType.IMAGE:
                    // eslint-disable-next-line no-undef
                    snapshot().then(function (url) {
                        self.$parent.$emit('loaded');
                        if (url !== undefined && url !== '') {
                            self.downloadFile(url);
                        }
                        else {
                            self.showExportingErrorModal();
                        }
                    }, function (re) {
                        console.error(new Date() + ' exportMap :: exportType.IMAGE', re);
                        self.showExportingErrorModal();
                    });
                    break;
                case self.exportType.PRINT:
                    // To be used when the method return a promise
                    // self.$parent.$emit('loading', {
                    //     title: self.$t('toolsSection.items.export.loaderTitle'),
                    //     message: self.$t('toolsSection.items.export.loaderMessage') + ' <strong>' + self.$t('toolsSection.items.export.print') + '</strong>',
                    // });
                    // impressio().then(function(url) {
                    //     self.$parent.$emit('loaded');
                    //     self.downloadFile(url);
                    // });
                    // eslint-disable-next-line no-undef
                    snapshot().then(function (url) {
                        self.$parent.$emit('loaded');
                        self.$emit('print', {
                            imageUrl: url,
                        });
                    }, function (re) {
                        console.error(new Date() + ' exportMap :: exportType.PRINT', re);
                        self.showExportingErrorModal();
                    });
                    break;
                case self.exportType.GEOPDF:
                    // eslint-disable-next-line no-undef
                    geoPdf(self.instamapsConfig).then(function (url) {
                        self.$parent.$emit('loaded');
                        if (url !== undefined && url !== '') {
                            self.downloadFile(url);
                        }
                        else {
                            self.showExportingErrorModal();
                        }
                    }, function (re) {
                        console.error(new Date() + ' exportMap :: exportType.GEOPDF', re);
                        self.showExportingErrorModal();
                    });
                    break;
                case self.exportType.GEOTIFF:
                    // eslint-disable-next-line no-undef
                    geoTiff(self.instamapsConfig).then(function (url) {
                        self.$parent.$emit('loaded');
                        if (url !== undefined && url !== '') {
                            self.downloadFile(url);
                        }
                        else {
                            self.showExportingErrorModal();
                        }
                    }, function (re) {
                        console.error(new Date() + ' exportMap :: exportType.GEOTIFF', re);
                        self.showExportingErrorModal();
                    });
                    break;
                case self.exportType.GEOPACKAGE:
                    // eslint-disable-next-line no-undef
                    geoPackage(self.instamapsConfig).then(function (url) {
                        self.$parent.$emit('loaded');
                        if (url !== undefined && url !== '') {
                            self.downloadFile(url, 'geopackage');
                        }
                        else {
                            self.showExportingErrorModal();
                        }
                    }, function (re) {
                        console.error(new Date() + ' exportMap :: exportType.GEOPACKAGE', re);
                        self.showExportingErrorModal();
                    });
                    break;
                case self.exportType.PRINTSCALE:
                    // eslint-disable-next-line no-undef              
                    printScale(self.instamapsConfig).then(function (url) {
                        self.$parent.$emit('loaded');
                        self.$emit('printScale', {
                            url: url,
                        });
                    }, function (re) {
                        console.error(new Date() + ' exportMap :: exportType.PRINTSCALE', re);
                        self.showExportingErrorModal();
                    });
                    break;
                case self.exportType.DOWNLOADLAYER:

                    break;
                default:
                    break;
            }
        },
        showExportingModal: function (exportType) {
            var exportTypeKey;

            switch (exportType) {
                case this.exportType.IMAGE:
                    exportTypeKey = 'image';
                    break;
                case this.exportType.PRINT:
                    exportTypeKey = 'print';
                    break;
                case this.exportType.GEOPDF:
                    exportTypeKey = 'geoPdf';
                    break;
                case this.exportType.GEOTIFF:
                    exportTypeKey = 'geoTiff';
                    break;
                case this.exportType.GEOPACKAGE:
                    exportTypeKey = 'geoPackage';
                    break;
                default:
                    break;
            }

            this.$parent.$emit('loading', {
                title: this.$t('toolsSection.items.export.loaderTitle'),
                message: this.$t('toolsSection.items.export.loaderMessage') + ' <strong>' + this.$t('toolsSection.items.export.' + exportTypeKey) + '</strong>',
            });
        },
        showExportingErrorModal: function () {
            this.$parent.$emit('loaded');
            this.$parent.$emit('loading', {
                title: this.$t('toolsSection.items.export.errorTitle'),
                message: this.$t('toolsSection.items.export.errorMessage'),
                isStatic: true,
                hasDismiss: true,
                isError: true,
            });
        },
        showDownloadModal: function () {
            this.$emit('downloadModal');
        },
        isLayerButtonVisible: function () {
            const optionsKey = this.isInIframe ? "iframe" : "visor";
            if (_.has(this.instamapsConfig, 'options')) {
                if (_.has(this.instamapsConfig.options, 'params')) {
                    return this.instamapsConfig.options.params[optionsKey].layerscontrol;
                }
            } else {
                return 0;
            }
        },
        isFonsButtonVisible: function () {
            const optionsKey = this.isInIframe ? "iframe" : "visor";
            if (_.has(this.instamapsConfig, 'options')) {
                if (_.has(this.instamapsConfig.options, 'params')) {
                    return this.instamapsConfig.options.params[optionsKey].fonscontrol;
                }
            } else {
                return 0;
            }
        },
        isExportButtonVisible: function () {
            const optionsKey = this.isInIframe ? "iframe" : "visor";
            if (_.has(this.instamapsConfig, 'options')) {
                if (_.has(this.instamapsConfig.options, 'params')) {
                    return this.instamapsConfig.options.params[optionsKey].snapshotcontrol;
                }
            } else {
                return 0;
            }
        },
        isGeoPackageButtonVisible: function () {
            const optionsKey = this.isInIframe ? "iframe" : "visor";
            if (_.has(this.instamapsConfig, 'options')) {
                if (_.has(this.instamapsConfig.options, 'params')) {
                    if (this.instamapsConfig.options.params[optionsKey].exportgpkgcontrol !== undefined) {
                        return this.instamapsConfig.options.params[optionsKey].exportgpkgcontrol;
                    }
                    else return 1;
                }
            } else {
                return 0;
            }
        },
        isSearchButtonVisible: function () {
            const optionsKey = this.isInIframe ? "iframe" : "visor";
            if (_.has(this.instamapsConfig, 'options')) {
                if (_.has(this.instamapsConfig.options, 'params')) {
                    if (this.instamapsConfig.options.params[optionsKey].searchcontrol !== undefined) {
                        return this.instamapsConfig.options.params[optionsKey].searchcontrol;
                    }
                    else {
                        return 1;
                    }
                }
            } else {
                return 1;
            }
        },
        isLegendButtonVisible: function () {
            return (this.state.legendItem && this.state.legendItem.items.length > 0 && this.legendVisible);
        },
        isAppsButtonVisible: function () {
            return !(!this.isLayerButtonVisible() && !this.isLegendButtonVisible() && !this.isFonsButtonVisible() && !this.isExportButtonVisible() && !this.is3dButtonVisible());
        },
        is3dButtonVisible: function () {
            const optionsKey = this.isInIframe ? "iframe" : "visor";
            return this.instamapsConfig &&
                this.instamapsConfig.options &&
                this.instamapsConfig.options.params &&
                this.instamapsConfig.options.params[optionsKey] &&
                this.instamapsConfig.options.params[optionsKey].control3d;
        },
        toggleSubelement: function (layerBusinessId, estilKey) {
            // eslint-disable-next-line no-undef 
            toggleSubCapa(layerBusinessId, estilKey);
        },
        getSubelementState: function (layerBusinessId, estilKey) {
            var currentCapa = _.find(this.layersState, { businessId: layerBusinessId });
            if (currentCapa !== undefined) {
                for (var i in currentCapa.layer._layers) {
                    var sublayer = currentCapa.layer._layers[i];
                    if (sublayer.properties.estil !== undefined) {
                        var estilBusinessId = sublayer.properties.estil.businessId;
                        if (estilBusinessId === estilKey) {
                            if (sublayer.activa === undefined) {
                                return true;
                            } else {
                                return sublayer.activa;
                            }
                        }
                    }
                    else if (sublayer.properties.codiEstil !== undefined) {
                        var estilBusinessId = sublayer.properties.codiEstil;
                        if (estilBusinessId === estilKey) {
                            if (sublayer.activa === undefined) {
                                return true;
                            } else {
                                return sublayer.activa;
                            }
                        }
                    }
                }
            }
            return "senseelements";
        },
        containsEstilKey: function (subelement) {
            return (subelement.estilKey !== undefined && subelement.estilKey !== null && subelement.estilKey !== "");
        },
        cleanResultName: function (nom) {
            var name = JSON.stringify(nom);
            (name.length > 30) ? name = name.substring(0, 30) + "..." : name;
            return name;
        },
        cleanResultName2: function (nom) {
            var name = JSON.stringify(nom);
            return name;
        },
        changeLayerState: function (layerBusinessId) {
            var self = this;
            var currentCapa = _.find(this.layersState, { businessId: layerBusinessId });
            if (currentCapa !== undefined) {
                for (var i in currentCapa.layer._layers) {
                    var sublayer = currentCapa.layer._layers[i];
                    if (sublayer.activa !== undefined && !sublayer.activa) {
                        self.toggleLayer(layerBusinessId);
                        return;
                    }

                }
            }
        },
    },
    mounted: function () {
        // eslint-disable-next-line no-undef 
        this.searchControl = new L.Control.Search();
    },

};



// WEBPACK FOOTER //
// ./src/map-viewer/components/floating-sidemenu/floating-sidemenu.js